import * as React from "react";

function SvgPlusIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190 190" {...props}><path d="M181.9 87.6h-79.3V8.4h-15v79.2H8.4v15h79.2v79.2h15v-79.2h79.3z" /></svg>;
}

export default SvgPlusIcon;